<div class="main_wrapper">
  <h3 class="tool-title">
    <img class="bottom" src="/assets/img/tools/annotator.png" /> Annotation
  </h3>
  <ul>
    <li style="word-break: break-word">
      <b style="font-size: 12px !important; padding-left: 5px !important"
        >Label</b
      >
      <div
        class="name"
        style="font-size: 11px !important; padding-left: 5px !important"
      >
        {{ data.name }}
      </div>
    </li>
    <li style="word-break: break-word" class="desc_b">
      <b style="font-size: 12px !important; padding-left: 5px !important"
        >Description</b
      ><br />
      <pre
        style="
          font-size: 11px !important;
          padding-left: 5px !important;
          border: none !important;
          font-family: arial !important;
          white-space: break-spaces !important;
          margin: 0px;
          padding: 0px 0px 4px 0px;

        "
        >{{ data.description }}</pre
      >
    </li>
  </ul>
  <ul *ngFor="let item of attributeList">
    <li style="word-break: break-word" class="desc_b">
      <b style="font-size: 12px !important; padding-left: 5px !important"
      >Label</b
    >
    <div
      class="name"
      style="font-size: 11px !important; padding-left: 5px !important"
    >
      {{ item.fieldname }}
    </div>
  </li >
    <li style="word-break: break-word" class="desc_b">
      <b style="font-size: 12px !important; padding-left: 5px !important"
      >Description</b
    ><br />
    <pre [innerHTML]="item.fieldname2"
      style="
        font-size: 11px !important;
        padding-left: 5px !important;
        border: none !important;
        font-family: arial !important;
        white-space: break-spaces !important;
        margin: 0px;
        padding: 0px;
      "
      ></pre
    >

      </li>
</ul>
  <div class="btn">
    <a
      class="closer button"
      [tooltip]="mapService.templatetoolTips['zoom_to_selection_right_panel']"
      [options]="myOptions12"
    >
      <img
        (click)="clickToZoom(data)"
        class="save-img common-btns"
        src="/assets/img/tools/zoom-to.png"
        alt="closer"
    /></a>
    <a class="closer button" [tooltip]="editTip" [options]="myEdit">
      <img
        (click)="edit(data)"
        class="google-img common-btns"
        src="/assets/img/tools/edit2.png"
        alt="back"
    /></a>
    <a class="closer button" [tooltip]="deleteTip" [options]="myDelete">
      <img
        class="delete_data common-btns"
        (click)="delete(data.id)"
        src="/assets/img/table/addRedX2.png"
        alt="back"
    /></a>

    <a
      class="closer button"
      [tooltip]="mapService.templatetoolTips['back_right_panel']"
      [options]="myBack"
    >
      <img
        (click)="goBack()"
        class="back-img common-btns"
        src="/assets/img/tools/back-pv3.png"
        alt="back"
    /></a>
    <a class="closer button">
      <img
        (click)="closeRightpanel()"
        [tooltip]="mapService.templatetoolTips['close_right_panel']"
        [options]="myClose"
        class="closer-img common-btns"
        src="/assets/img/tools/close-pv3.png"
        alt="closer"
    /></a>
  </div>
</div>
